




































































import { Component, Mixins } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

@Component
export default class ContentPickerSearchSuggestions extends Mixins() {
  @namespace('contentPicker').Getter searchSuggestions!: string[]

  @namespace('contentPicker').Action setSearchQuery!: (payload: { query: string }) => void
  @namespace('contentPicker').Action search!: (payload?: { query: string }) => void

  searchFor(suggestion: string): void {
    this.setSearchQuery({ query: suggestion })
    this.search()
  }
}
